import React from 'react'
import { exportFile } from 'Tyan/public/index'
import { getChangedFieldsets, hasChangedValues, changeItemsValue, getFormValue } from 'tyan/public/utility'

class OperationRuleDetail extends React.Component {
	state = {
		id: this.props.id || 0,
		readOnly: this.props.readOnly || false,
	}

	componentDidMount = () => {
		this.doGetOperationRule(this.state.id)
	}

	doGetOperationRule = (id) => {
		Tyan.doPostEvent('GetOperationRule', {
			data: { id },
			onEnd: ({ errorMessage, optionsParas, initValues基本信息, }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					this.setState({ id, optionsParas, initValues基本信息, changedValues基本信息: {}, })
				}
			}
		})
	}

	handlerSave = () => {
		const { id } = this.state
		Tyan.doPostEvent('SaveOperationRule', {
			data: getChangedFieldsets(this, '基本信息', false),
			onEnd: ({ errorMessage, id }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					Ext.toast('保存成功')
					this.doGetOperationRule(id)
				}
			}
		})
	}

	handlerDelete = () => {
		const { onClose } = this.props
		const { id } = this.state
		Tyan.pubForm.showConfirm('确定要删除？', () => {
			Tyan.doPostEvent('DelOperationRule', {
				data: { id },
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					} else {
						Ext.toast('删除成功')
						onClose && onClose()
					}
				}
			})
		})
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	handlerPrint = () => {
		const { id } = this.state
		Tyan.doPostEvent('PrintOperationRule', {
			data: { id },
			onEnd: ({ errorMessage, FID }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					exportFile(null, null, "GetFile?FID=" + FID)
				}
			}
		})
	}


	canSave = () => {
		return !Tyan.checkForm.checkLimited(this) && getFormValue(this, '基本信息', '版本') && getFormValue(this, '基本信息', '内容')
	}

	bChanged = () => {
		return hasChangedValues(this)
	}

	handlerChange = (v) => {
		Tyan.doPostEvent('GetRelationInfo', {
			data: { type: '设备编号BLL', objRelationInfo: { '设备': v } },
			onEnd: ({ errorMessage, optionsParas, objInfo }) => {
				if (optionsParas) {
					this.setState({ optionsParas: { ...this.state.optionsParas, ...optionsParas } })
				}
				if (objInfo) {
					changeItemsValue(this, '基本信息',
						['设备编号', '设备名称', '设备型号'],
						[objInfo.InstrumentNumber, objInfo.InstrumentName, objInfo.F1])
				}
			}
		})
	}

	fieldset基本信息 = () => {
		return [
			{ _select: '设备编号', required: true, editable: true, forceSelection: false, onChange: (v) => this.handlerChange(v) },
			{
				_group: '', name: '版本次数', margin: 0, items: [
					{ _text: '版本', required: true, minWidth: 100, },
					{ _int: '更改次数', minWidth: 100, textAlign: 'left', },
				]
			},
			{ _text: '设备名称', disabled: true, },
			{ _text: '设备型号', disabled: true, },
			{ _text: '内容', required: true, minWidth: '100%', maxRows: 20, richtext: true, },
			{ _files: '附件', minWidth: '100%', },
		]
	}

	render() {
		const { showMessage: Message, showBody: Body } = this.props
		const { id, readOnly, initValues基本信息, } = this.state
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />

		const bCanSave = this.canSave()
		const bChanged = this.bChanged()
		const { 状态: statusName } = initValues基本信息
		const bEdit = statusName == '编制中'
		return <Body data={this} maxWidth={1000}
			controls={
				readOnly ? [
					{ _button: '预览', handler: this.handlerPrint },
					{ _button: '关闭', handler: this.handlerClose }
				] : [
						{ _flow: 'OperationRuleFlow', disabled: !bCanSave || bChanged, cdt: () => id > 0 },
						{ _button: '预览', handler: this.handlerPrint, disabled: bChanged, cdt: () => id > 0 },
						{ _button: '保存', handler: this.handlerSave, disabled: !(bChanged && bCanSave), cdt: () => bEdit },
						{ _button: '删除', handler: this.handlerDelete, cdt: () => id > 0 && bEdit },
						{ _button: bChanged && '取消' || '关闭', handler: this.handlerClose },
					]
			}
			fieldsets={
				[
					{ title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: readOnly || !bEdit },
				]}
		/>
	}
}

export default OperationRuleDetail